import { createContext } from 'react';

import { useScroll } from '../../hooks/index.js';

export type PanelContextValue = ReturnType<typeof useScroll>;

export const PanelContext = createContext<PanelContextValue>(null as any);
